export interface TwoFactorStatus {
    enabled: boolean
    factorType: string | null
    enabledAt: string | null
    issuer: string
    accountName: string
}

export interface TwoFactorEnrollment {
    id: string
    secret: string
    otpauthUri: string
    issuer: string
    accountName: string
    expiresAt: string
}

export const TWO_FACTOR_CODE_LENGTH = 6

export const twoFactorEndpoints = {
    status: "/auth/user/mfa",
    enrollments: "/auth/user/mfa/enrollments",
    activation: (enrollmentId: string) => `/auth/user/mfa/enrollments/${enrollmentId}/activations`,
    deactivation: "/auth/user/mfa/deactivations",
    challengeVerification: (challengeId: string) =>
        `auth/mfa/challenges/${challengeId}/verifications`,
}

export enum TwoFactorErrorCode {
    Required = "mfa_required",
    ChallengeExpired = "mfa_challenge_expired",
    CodeInvalid = "mfa_code_invalid",
    EnrollmentNotFound = "mfa_enrollment_not_found",
    AlreadyEnabled = "mfa_already_enabled",
    NotEnabled = "mfa_not_enabled",
}

export const getTwoFactorErrorCode = (error: any): string | undefined =>
    error?.response?.data?.data?.code

export const formatAccountLabel = (issuer: string, accountName: string) =>
    `${issuer} (${accountName})`

export const formatSetupKey = (secret: string) => secret.replace(/(.{4})(?=.)/g, "$1 ")
